import React from "react";

function Terms() {
  return (
    <div className="page">
      <div className="card" style={{ maxWidth: "900px", margin: "40px auto" }}>
        <h1 className="title">Terms of Use</h1>
        <p className="subtitle">
          Please read these Terms of Use carefully before using Driveodi.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By creating an account or using this application, you agree to be bound
          by these Terms of Use.
        </p>

        <h2>2. Use of the Service</h2>
        <p>
          Driveodi is provided to help instructors manage students, lessons,
          skills, and subscription-based access to the platform. You agree to use
          the service lawfully and responsibly.
        </p>

        <h2>3. Account Responsibility</h2>
        <p>
          You are responsible for maintaining the confidentiality of your login
          credentials and for all activity that takes place under your account.
        </p>

        <h2>4. Subscription and Billing</h2>
        <p>
          Certain features of the service require an active subscription or valid
          trial period. Billing is handled through Stripe. Trial periods, payment
          attempts, failed payments, cancellations, and subscription status are
          governed by the subscription system connected to your account.
        </p>

        <h2>5. Service Availability</h2>
        <p>
          We aim to keep the service available and reliable, but we do not
          guarantee uninterrupted access at all times.
        </p>

        <h2>6. Acceptable Use</h2>
        <p>
          You agree not to misuse the platform, attempt unauthorized access,
          interfere with the service, or use the platform in any way that may
          harm the business, service, or other users.
        </p>

        <h2>7. Data and Records</h2>
        <p>
          You are responsible for the accuracy of the data you enter into the
          platform, including student information, lessons, and related records.
        </p>

        <h2>8. Termination</h2>
        <p>
          We reserve the right to suspend or terminate access where necessary,
          including in cases of misuse, non-payment, abuse, or security concerns.
        </p>

        <h2>9. Changes to These Terms</h2>
        <p>
          These terms may be updated from time to time. Continued use of the
          service after updates means you accept the revised terms.
        </p>

        <h2>10. Contact</h2>
        <p>
          For questions about these Terms of Use, please contact BCO DataSoft
          Solutions.
        </p>
      </div>
    </div>
  );
}

export default Terms;